import {
  Box,
  CircularProgress,
  Divider,
  Stack,
  Typography,
} from '@mui/material';
import { AppPrimaryButton } from 'shared/components/AppComponents';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { PoliciesService } from 'services';
import { Utils } from 'shared/helpers';

const PolicyAcknowledgement: React.FC = () => {
  const { ackId } = useParams();
  const [isAcknowledging, setIsAcknowledging] = useState(false);
  const [step, setStep] = useState(0);
  const [isLoadingDetail, setIsLoadingDetail] = useState(false);
  const [policyDetail, setPolicyDetail] = useState({ policyName: '' });
  const [ackDate, setAckDate] = useState(new Date());

  // API Calls
  const loadPolicyDetails = (): void => {
    setIsLoadingDetail(false);
  };

  // UI Actions
  const actionOnAcknowledge = (): void => {
    setIsAcknowledging(true);
    PoliciesService.acknowledgePolicy(`${ackId}`, {})
      .then((response) => {
        const { data } = response.data;
        setPolicyDetail(data);
        setStep(1);
        setAckDate(new Date());
      })
      .catch((error) => {
        Utils.handleErrorResponse(error);
        setIsAcknowledging(false);
      });
  };

  // Hooks
  useEffect(() => {
    loadPolicyDetails();
  }, []);

  // UI Elements
  return (
    <>
      {isLoadingDetail && (
        <Box className="empty-content">
          <CircularProgress />
        </Box>
      )}
      {!isLoadingDetail && (
        <Stack alignItems="center" className="p-10 policy-acknowledge">
          {step === 0 && (
            <Box className="app-card">
              <Box className="title">
                <Typography variant="h4">
                  Policy Acknowledgement Required
                </Typography>
              </Box>
              <Box className="content">
                <Typography className="f18 fw-6 mb-2">
                  Policy Acknowledgement
                </Typography>
                <Typography variant="body1">
                  Please review and acknowledge this policy to confirm your
                  understanding and compliance
                </Typography>
                <Stack spacing={2} className="ack-button-section">
                  <Stack direction="row" alignItems="center">
                    <Typography className="text-primary" variant="body1">
                      Ready to Acknowledge
                    </Typography>
                  </Stack>
                  <Typography variant="body1">
                    Buy Clicking the button below, you confirm that you have
                    read, understood, and agree to comply with this policy
                  </Typography>
                  <AppPrimaryButton
                    isLoading={isAcknowledging}
                    onClick={actionOnAcknowledge}
                    startIcon={<TaskAltIcon />}
                    title="I Acknowledge This Policy"
                  />
                </Stack>
                <Divider />
                <Typography textAlign="center" variant="body1" className="mt-2">
                  This acknowledgement will be recorded with a timestamp for
                  compliance purpose
                </Typography>
              </Box>
            </Box>
          )}
          {step === 1 && (
            <Box className="app-card">
              <Box className="title">
                <Typography textAlign="center" variant="h4">
                  Policy Acknowledged Successfully
                </Typography>
              </Box>
              <Box className="content">
                <Stack spacing={2} className="ack-button-section">
                  <Typography variant="body1">
                    Thank you for acknowledging the policy
                  </Typography>
                  <Stack direction="row" alignItems="center">
                    <Typography className="text-primary" variant="body1">
                      {policyDetail.policyName}
                    </Typography>
                  </Stack>
                  <Typography variant="body1">
                    Your acknowledgement has been recorded on{' '}
                    {ackDate.toLocaleString()}
                  </Typography>
                </Stack>
              </Box>
            </Box>
          )}
        </Stack>
      )}
    </>
  );
};

export default PolicyAcknowledgement;
